/*
 * 1DS JS SDK QoS plugin, 3.2.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* id.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2018
*/
import dynamicProto from "@microsoft/dynamicproto-js";
import { createGuid, generateW3CId } from "@microsoft/1ds-core-js";
var Id = /** @class */ (function () {
    function Id(core) {
        var lastPageViewId = createGuid();
        var internalTraceId = generateW3CId();
        dynamicProto(Id, this, function (_self) {
            _self.getTraceId = function () {
                if (core && core.getTraceCtx) {
                    return core.getTraceCtx().getTraceId() || internalTraceId;
                }
                return internalTraceId;
            };
            _self.getLastPageViewId = function () {
                return lastPageViewId;
            };
        });
    }
// Removed Stub for Id.prototype.getTraceId.
// Removed Stub for Id.prototype.getLastPageViewId.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    Id.__ieDyn=1;

    return Id;
}());
export default Id;
//# sourceMappingURL=Id.js.map